'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuiTabPane',
  meta: {
    parent: 'SuiTab'
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    label: {
      type: String
    },
    attached: {
      type: [Boolean, String],
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    classList: function classList() {
      var list = ['ui', 'tab', 'segment', { loading: this.active && this.loading }, { attached: this.attached }, { active: this.active }];

      if (typeof this.attached === 'string') {
        list.push(this.attached);
      }

      return list;
    }
  },
  mounted: function mounted() {
    try {
      this.findParent().addTab(this);
    } catch (e) {
      throw new Error('tab-pane was placed outside of tab component');
    }
  },

  methods: {
    findParent: function findParent() {
      var parent = this.$parent;
      var name = _Tab2.default.name;

      while (parent.$options.name !== name) {
        parent = parent.$parent;
      }

      return parent;
    },
    open: function open() {
      this.active = true;
    },
    close: function close() {
      this.active = false;
    }
  },
  render: function render() {
    var h = arguments[0];

    return this.active && h(
      'div',
      { 'class': this.classList },
      [this.$slots.default]
    );
  }
};